import { Box } from '@material-ui/core'

import { PagesProps } from '../../../../@types'
import { MainTitle } from '../../../../components'

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       fleGrow: 1
//     }
//   }),
// )

export const Resources = ({ page }: PagesProps) => {
	// const classes = useStyles()

	return (
		<Box>
			<MainTitle
				breadcrumbs={[page]}
				title={page.name}
				description="All the teacher resources you´ll need to get up and running in no time!"
			/>
		</Box>
	)
}
